'use client';

import type { LengthUnit } from '@/lib/tools/units';
import { optionChipClass } from '@/components/room/chrome/selection';

export default function UnitToggle({ unit, onChange, className = '' }: {
  unit: LengthUnit;
  onChange: (unit: LengthUnit) => void;
  className?: string;
}) {
  return (
    <div
      className={`inline-flex items-center gap-1 rounded-lg border border-[var(--app-border)] p-0.5 ${className}`}
      role="group"
      aria-label="Length unit"
      data-testid="unit-toggle"
      // The page registry's "units-ft-m" feature, proven to the crawl gate.
      data-seo="units-ft-m"
    >
      {(['m', 'ft'] as const).map((u) => (
        <button
          key={u}
          type="button"
          onClick={() => onChange(u)}
          // SELECTION IS NOT AN ACTION: the chosen unit reads as raised, never
          // accent-filled (AGENTS.md's Button + selection rule) — see selection.ts.
          className={optionChipClass(unit === u)}
          aria-pressed={unit === u}
        >
          {u === 'm' ? 'Meters' : 'Feet'}
        </button>
      ))}
    </div>
  );
}
